import { createContext, useContext } from 'react';

import type { MyAccountContextValue } from 'pages/account/my_account/MyAccount';

export const MyAccountContext = createContext({} as MyAccountContextValue);
MyAccountContext.displayName = 'MyAccountContext';

export const useMyAccount = () => useContext(MyAccountContext);
